import { CdkMenuModule } from '@angular/cdk/menu';
import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { PalantirAvatarComponent } from '../../../../avatar/avatar.component';
import { PalantirAvatarGroupComponent } from '../../../../avatar-group/avatar-group.component';
import { PalantirIconComponent } from '../../../../icon/icon.component';
import { PalantirTooltipModule } from '../../../../tooltip/tooltip.module';
import type { PalantirTableAvatar } from './avatar-group.type';

@Component({
  selector: 'palantir-table-avatar-group',
  templateUrl: './avatar-group.component.html',
  styleUrls: ['./avatar-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CdkMenuModule,
    PalantirAvatarComponent,
    PalantirIconComponent,
    PalantirTooltipModule,
    PalantirAvatarGroupComponent,
  ],
})
export class PalantirTableAvatarGroupComponent implements OnInit {
  @Input({ required: true }) public avatars: PalantirTableAvatar[] = [];

  @Input() public maxItems: number = 3;

  @Input() public extraItemsTooltip: string = '';

  @Input() public action?: (value: PalantirTableAvatar) => Promise<void> | void;

  public extraAvatarTooltipsNames = signal<string>('');

  public ngOnInit(): void {
    this.extraAvatarTooltipsNames.set(this.setListOfAvatarHiddenNames());
  }

  private setListOfAvatarHiddenNames(): string {
    if (!this.avatars?.length || this.avatars?.length <= this.maxItems) {
      return '';
    }

    const hiddenAvatars = this.avatars.slice(this.maxItems || 3);
    return hiddenAvatars.map((avatar) => avatar?.label ?? '').join('\n');
  }
}
